module.exports = __webpack_public_path__ + "static/media/sk-SK.2d8da30e.md";